import React from "react"
import { FormattedMessage } from "react-intl"
import arrowDown from "assets/icons/arrow-down-positive-amount.svg"
import arrowUp from "assets/icons/arrow-up-positive-amount.svg"

interface FormattingText {
	prefix?: string | React.ReactNode
	suffix?: string | React.ReactNode
}

export const SALES = "Sales"
export const AVGTICKET = "AvgTicket"
export const PRICEPERITEM = "PricePerItem"
export const ITEMSPERVISIT = "ItemsPerVisit"
export const TOTALITEMSOLD = "TotalItemsSold"
export const TRANSACTIONS = "Transactions"
export const PURCHASEFRECUENCY = "PurchaseFrequency"
export const REACH = "Reach"
export const TIMEBTWPURCHASE = "TimeBtwPurchase"
export const RECENCY = "Recency"
export const CUSTOMERS = "Customers"
export const SPENDBYCUSTOMER = "SpendByCustomer"
export const DEFAULT = "Default"
export const LOADING = "Loading"
export const NEGATIVE = "negative"
export const POSITIVE = "positive"

export const formattingText: Record<string, FormattingText> = {
	[SALES]: {
		prefix: "$",
	},
	[AVGTICKET]: {
		prefix: "$",
	},
	[PRICEPERITEM]: {
		prefix: "$",
	},
	[ITEMSPERVISIT]: {
		suffix: (
			<FormattedMessage id="phronesis.transactional.application.growth-profiling.items" />
		),
	},
	[TOTALITEMSOLD]: {},
	[TRANSACTIONS]: {},
	[PURCHASEFRECUENCY]: {},
	[REACH]: {
		suffix: "%",
	},
	[TIMEBTWPURCHASE]: {
		suffix: <FormattedMessage id="phronesis.common.temporal.days" />,
	},
	[RECENCY]: {},
	[CUSTOMERS]: {},
	[SPENDBYCUSTOMER]: {
		prefix: "$",
	},
	[DEFAULT]: {
		prefix: "$",
		suffix: "$",
	},
}

export const DEPARTMENT_MARKET_TITLE =
	"phronesis.transactional.application.growth-profiling.chart.market.department"

export const CATEGORIES_MARKET_TITLE =
	"phronesis.transactional.application.growth-profiling.chart.market.categories"

export const SUB_CATEGORIES_MARKET_TITLE =
	"phronesis.transactional.application.growth-profiling.chart.market.sub.categories"

export const EMPTY_FILTER = 0

export const formatProps = {
	[POSITIVE]: {
		color: "green",
		arrow: arrowUp,
	},
	[NEGATIVE]: {
		color: "red",
		arrow: arrowDown,
	},
}
